/**
 * Junta classes condicionais.
 *
 * Deliberadamente simples: a aplicacao usa variantes declaradas nos proprios
 * componentes, e nao composicao arbitraria de utilidades conflitantes. Enquanto
 * for assim, resolver conflito de classe em tempo de execucao seria peso sem
 * beneficio.
 */
export function cn(...values: Array<string | false | null | undefined>): string {
  return values.filter(Boolean).join(' ');
}
